import {Component} from '@angular/core';
import {SalesFinalMessageKredicashComponent} from '../sales-final-message-kredicash.component';

@Component({
  selector: 'app-sales-final-message-kredicash-v2',
  templateUrl: './sales-final-message-kredicash-v2.component.html'
})
export class SalesFinalMessageKredicashV2Component extends SalesFinalMessageKredicashComponent {}

@Component({
  selector: 'app-sales-final-message-kredicash-v3',
  templateUrl: './sales-final-message-kredicash-v3.component.html',
})
export class SalesFinalMessageKredicashV3Component extends SalesFinalMessageKredicashComponent {}
